module.exports = __webpack_public_path__ + "img/padlock.b8eda27e.svg";